import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../src/backoffice/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_buefy_2a57fd73 from 'nuxt_plugin_buefy_2a57fd73' // Source: ./buefy.js (mode: 'client')
import nuxt_plugin_pluginutils_b7ed8f4e from 'nuxt_plugin_pluginutils_b7ed8f4e' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_7c9d1364 from 'nuxt_plugin_pluginrouting_7c9d1364' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_f0019aea from 'nuxt_plugin_pluginmain_f0019aea' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_6878fe22 from 'nuxt_plugin_axios_6878fe22' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_dompurify_a59fb11a from 'nuxt_plugin_dompurify_a59fb11a' // Source: ../../../src/shared/vue/plugins/dompurify (mode: 'all')
import nuxt_plugin_directives_2220af62 from 'nuxt_plugin_directives_2220af62' // Source: ../../../src/shared/vue/plugins/directives (mode: 'all')
import nuxt_plugin_filters_bd8db946 from 'nuxt_plugin_filters_bd8db946' // Source: ../../../src/shared/vue/plugins/filters (mode: 'all')
import nuxt_plugin_moment_4b488e5e from 'nuxt_plugin_moment_4b488e5e' // Source: ../../../src/shared/vue/plugins/moment (mode: 'all')
import nuxt_plugin_goToLocalePath_4d9889e0 from 'nuxt_plugin_goToLocalePath_4d9889e0' // Source: ../../../src/shared/vue/plugins/goToLocalePath (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../../../src/backoffice/plugins/axios (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../../../src/backoffice/plugins/vee-validate (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../../../src/backoffice/plugins/i18n (mode: 'all')
import nuxt_plugin_vuefrag_9dc29162 from 'nuxt_plugin_vuefrag_9dc29162' // Source: ../../../src/backoffice/plugins/vue-frag (mode: 'all')
import nuxt_plugin_jsoneditor_0fbe08bc from 'nuxt_plugin_jsoneditor_0fbe08bc' // Source: ../../../src/backoffice/plugins/json-editor (mode: 'all')
import nuxt_plugin_auth_28215ece from 'nuxt_plugin_auth_28215ece' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../../../src/backoffice/plugins/auth (mode: 'all')
import nuxt_plugin_sentry_3c12fa56 from 'nuxt_plugin_sentry_3c12fa56' // Source: ../../../src/backoffice/plugins/sentry (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Claims IA","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Claims IA"}],"script":[{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Face-builds@latest\u002Fsrc-noconflict\u002Face.min.js","async":false,"defer":false},{"src":"\u002Fenv.js?1793629605881","async":false,"defer":false},{"src":"\u002Fsetup.js?1793629605881","async":false,"defer":false}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@7.4.47\u002Fcss\u002Fmaterialdesignicons.min.css","defer":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_buefy_2a57fd73 === 'function') {
    await nuxt_plugin_buefy_2a57fd73(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_b7ed8f4e === 'function') {
    await nuxt_plugin_pluginutils_b7ed8f4e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_7c9d1364 === 'function') {
    await nuxt_plugin_pluginrouting_7c9d1364(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_f0019aea === 'function') {
    await nuxt_plugin_pluginmain_f0019aea(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_6878fe22 === 'function') {
    await nuxt_plugin_axios_6878fe22(app.context, inject)
  }

  if (typeof nuxt_plugin_dompurify_a59fb11a === 'function') {
    await nuxt_plugin_dompurify_a59fb11a(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_2220af62 === 'function') {
    await nuxt_plugin_directives_2220af62(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_bd8db946 === 'function') {
    await nuxt_plugin_filters_bd8db946(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_4b488e5e === 'function') {
    await nuxt_plugin_moment_4b488e5e(app.context, inject)
  }

  if (typeof nuxt_plugin_goToLocalePath_4d9889e0 === 'function') {
    await nuxt_plugin_goToLocalePath_4d9889e0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_vuefrag_9dc29162 === 'function') {
    await nuxt_plugin_vuefrag_9dc29162(app.context, inject)
  }

  if (typeof nuxt_plugin_jsoneditor_0fbe08bc === 'function') {
    await nuxt_plugin_jsoneditor_0fbe08bc(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_28215ece === 'function') {
    await nuxt_plugin_auth_28215ece(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_sentry_3c12fa56 === 'function') {
    await nuxt_plugin_sentry_3c12fa56(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
